import { ROOM_TYPE } from './room-type.js';

const ROOM_TYPE_LIST = Object.values(ROOM_TYPE);

export { ROOM_TYPE_LIST };
//# sourceMappingURL=room-type-list.js.map
